import React , { useState }from "react";
import { sendToPanelDeliverApi } from "../../../../Api/PanelAdminServices";
import Button from "../../../Button/Button";
import Style from "./UserInfo.module.scss";

const UserInfo = ({ handleOk, Info, address, showAddress }) => {
  console.log(Info.userId)
  const[disable,setDisable]=useState(false)
  console.log(Info)
  const goToPanel = () => {
    setDisable(true) 
    const info = {
      user_id: Info.userId??Info.user_id,
      user_type: "user",
    };
    sendToPanelDeliverApi(info, (res) => {
      setDisable(false)
      window.open(
        `https://barest.ir/login_as/index.php?token=${res.token}`
      );
    });
  };
  return (
    <div className={Style.componentHolder}>
      <div className={Style.infoHolder}>
        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleLname}>نام مشتری</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.Lname}>{`${Info?.first_name} ${Info?.last_name}`}</p>
          </div>
        </div>

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleEmail}>ایمیل</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.email}>
              {Info.email ? Info.email : " !ایمیل وجود ندارد"}
            </p>
          </div>
        </div>

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titlePhone}>شماره تماس</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.phone}>{Info.phone}</p>
          </div>
        </div>
        {showAddress ? (
          <div className={Style.row}>
            <div className={Style.titleHolder}>
              <p className={Style.titleAddress}>آدرس</p>
            </div>
            <div className={Style.contentHolder}>
              <p className={Style.address}>{Info.address}</p>
            </div>
          </div>
        ) : null}
      </div>
      <div className={Style.btnHolder}>
        <Button
          Value={"وارد شدن به پنل مشتری"}
          ClickHandler={goToPanel}
          ClassBtn={"okBtn"}
          disabledprops={disable}
        />
        <Button Value={"تایید"} ClickHandler={handleOk} ClassBtn={"okBtn"} />

      </div>
    </div>
  );
};

export default UserInfo;
